export type OdometerFeature = 'distance/primary' | 'distance/gps';

export const ODOMETER_FEATURES: OdometerFeature[] = ['distance/primary', 'distance/gps'];

export const GPS_ODOMETER_FEATURE: OdometerFeature = 'distance/gps';

export const PRIMARY_ODOMETER_FEATURE: OdometerFeature = 'distance/primary';

export interface OdometerRawReading {
  feature: OdometerFeature;
  rawValueMeters: number;
  occurred: Date;
}

export interface OdometerReading extends OdometerRawReading {
  calibratedValueMeters: number;
  appliedOffsetMeters: number;
}
